import styled from 'styled-components';

// Seguir patrones de ActionForms/styles.ts y management forms
export const WorkEquipmentSections = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spaces.xxl}rem;
`;

export const EquipmentSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spaces.l}rem;
`;

export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spaces.l}rem;
`;
